export const LINK_TYPE = {
    INTERNAL: 'internal',
    EXTERNAL: 'external',
    ANCHOR: 'anchor',
}